import { useEffect, useState } from 'react';

export const useOneTimeModal = (modalKey, config = {}) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const userId = localStorage.getItem('user_id');

    let modalObj = {};

    try {
      modalObj = JSON.parse(localStorage.getItem(modalKey)) || {};
    } catch (e) {
      modalObj = {};
    }
    const shouldShow = modalObj[userId] !== false;
    const timeout = setTimeout(() => {
      setModalOpen(shouldShow);
    }, config.delay || 0);

    return () => clearTimeout(timeout);
  }, []);

  const closeModal = () => {
    const userId = localStorage.getItem('user_id');

    let modalObj = {};

    try {
      modalObj = JSON.parse(localStorage.getItem(modalKey)) || {};
    } catch (e) {
      modalObj = {};
    }

    modalObj[userId] = false;
    localStorage.setItem(modalKey, JSON.stringify(modalObj));
    setModalOpen(false);
  };

  return { modalOpen, closeModal };
};
